var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inline-image", on: { dblclick: _vm.onDoubleClick } },
    [
      _c("file-modal-component", {
        attrs: {
          show: _vm.showModal,
          value: _vm._.get(_vm.initialValue, "id"),
          closeModal: _vm.closeModal,
          extensions: _vm.schema.extensions
        },
        on: { change: _vm.updateValue }
      }),
      _vm._v(" "),
      _c("img", {
        style: _vm.css,
        attrs: { src: _vm._.imgPath(_vm.initialValue, "w80") }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4126437b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4126437b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/InlineImageComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4126437b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/InlineImageComponent.vue
// module chunks = 0